import axiosInstance from "../axiosInstance";

class QuestionnaireAPI {
  // ==================== ADMIN APIs ====================

  // Create questionnaire template
  static async createQuestionnaireTemplate(data) {
    try {
      const response = await axiosInstance.post(
        "/questionnaires/admin/template",
        data
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Get all questionnaire templates with pagination and search
  static async getAllQuestionnaireTemplates(params = {}) {
    try {
      const response = await axiosInstance.get(
        "/questionnaires/admin/templates",
        {
          params,
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Update questionnaire template
  static async updateQuestionnaireTemplate(id, data) {
    try {
      const response = await axiosInstance.put(
        `/questionnaires/admin/template/${id}`,
        data
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Soft delete questionnaire template
  static async deleteQuestionnaireTemplate(id) {
    try {
      const response = await axiosInstance.delete(
        `/questionnaires/admin/template/${id}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Get all questionnaire responses with filters
  static async getAllQuestionnaireResponses(params = {}) {
    try {
      const response = await axiosInstance.get(
        "/questionnaires/admin/responses",
        {
          params,
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // ==================== USER APIs (for admin to view) ====================

  // Get unanswered questionnaires for a specific user
  static async getUserUnansweredQuestionnaires(userId) {
    try {
      const response = await axiosInstance.get(`/questionnaires/unanswered`, {
        params: { userId },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Get user's questionnaire responses
  static async getUserQuestionnaireResponses(userId) {
    try {
      const response = await axiosInstance.get(
        `/questionnaires/user/responses`,
        {
          params: { userId },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
}

export default QuestionnaireAPI;
